import { render, staticRenderFns } from "./simpleTable.vue?vue&type=template&id=2b9ebc7f&scoped=true"
import script from "./simpleTable.vue?vue&type=script&lang=js"
export * from "./simpleTable.vue?vue&type=script&lang=js"
import style0 from "./simpleTable.vue?vue&type=style&index=0&id=2b9ebc7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9ebc7f",
  null
  
)

export default component.exports